<div class="flex abs">
  <div class="half login-bkg"></div>
  <div class="half"></div>
</div>
<div class="flex abs" style="z-index: 1; justify-content: center;">
  <div class="container">
    <img class="login-graph" src="/assets/images/graph-line2.png">
    <span class="login-learn">{{ 'login.learnMore' | translate }}
      <a class="login-link secondary" href="http://flywheel.io" target="_blank">flywheel.io</a>
    </span>
    <div class="container login-content">
      <div class="half">
        <h1 class="login-statement">{{ 'login.title' | translate }}</h1>
      </div>
      <div class="flex half form-container">
        <div class="card login-card" *ngIf="features.ldap || features.basicAuth; else noProviders">
          <img class="login-logo" src="/assets/images/Flywheel-Logo-Light-BG.svg">
        
          <ng-container *ngIf="!activeAuthMethod">
            <fw-button *ngIf="features.ldap" test-id="login-ldap-button" color="slate" variant="outline" [fullWidth]="true" (click)="activeAuthMethod = 'ldap'">
              {{ 'login.auth.withLDAP' | translate }}
            </fw-button>
            <fw-button *ngIf="features.basicAuth" test-id="login-basic-button" color="slate" variant="outline" [fullWidth]="true" (click)="activeAuthMethod = 'basic'">
              {{ 'login.auth.withPassword' | translate }}
            </fw-button>
          </ng-container>

          <ng-container *ngIf="activeAuthMethod === 'ldap'">
            <form [formGroup]="authForm">
              <div class="form-group">
                <label>{{ ldapUserOverride || ('common.labels.emailAddress' | translate) }}</label>
                <input test-id="login-email-address-input" formControlName="username" type="text" class="form-control">
              </div>
              <div class="form-group">
                <label>{{ 'login.password' | translate }}</label>
                <input test-id="login-password-input" formControlName="password" type="password" class="form-control">
              </div>
              <fw-button type="submit" (click)="loginWithLdap()" [fullWidth]="true" [disabled]="authForm.invalid">
                {{ 'login.signIn' | translate }}
              </fw-button>
              <fw-button color="slate" variant="outline" [fullWidth]="true" (click)="activeAuthMethod = null">
                {{ 'common.actions.cancel' | translate }}
              </fw-button>
            </form>
            <div class="tip">
              <strong>{{ 'login.auth.basicLogin' | translate }}</strong>
              <p class="text-muted">{{ 'login.auth.ldapReasurance' | translate }}</p>
            </div>
          </ng-container>

          <ng-container *ngIf="activeAuthMethod === 'basic'">
            <form [formGroup]="authForm">
              <p class="basic-warning">{{ 'login.auth.basicWarning'| translate }}</p>
              <div class="form-group">
                <label>{{ 'common.labels.emailAddress' | translate }}</label>
                <input test-id="login-email-address-input" formControlName="username" type="text" class="form-control">
              </div>
              <div class="form-group">
                <label>{{ 'login.password' | translate }}</label>
                <input test-id="login-password-input" formControlName="password" type="password" class="form-control">
              </div>
              <fw-button type="submit" (click)="loginWithBasicAuth()" [fullWidth]="true" [disabled]="authForm.invalid">
                {{ 'login.signIn' | translate }}
              </fw-button>
              <fw-button color="slate" variant="outline" [fullWidth]="true" (click)="activeAuthMethod = null">
                {{ 'common.actions.cancel' | translate }}
              </fw-button>
            </form>
            <div class="tip">
              <strong>{{ 'login.auth.basicLogin' | translate }}</strong>
              <p class="text-muted">{{ 'login.auth.basicReasurance' | translate }}</p>
            </div>
          </ng-container>
        </div>
        <p *ngIf="loginError" class="basic-warning" style="max-width: 385px">
          {{ 'login.contactAdmin' | translate }} - {{ loginError }}
        </p>
        <ng-template #noProviders>
          <div class="card login-card">
            <img class="login-logo" src="/assets/images/Flywheel-Logo-Light-BG.svg">
            <span>{{ 'login.noProviders' | translate }}</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>